import React from "react";
import { Link } from "react-router-dom";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-black text-white pt-20">
      <div className="max-w-7xl mx-auto px-8 grid md:grid-cols-4 gap-12 pb-16">
        {/* COMPANY INFO */}

        <div>
          <h3 className="text-2xl font-bold mb-4">
            <span className="text-blue-400">Lumis</span> Documents
          </h3>

          <p className="text-gray-400 text-sm leading-relaxed">
            Lumis Documents Clearing provides professional visa processing,
            immigration consulting and document clearing services helping
            individuals and businesses explore global opportunities with
            confidence.
          </p>
        </div>

        {/* QUICK LINKS */}

        <div>
          <h3 className="text-xl font-semibold mb-6">Quick Links</h3>

          <ul className="space-y-3 text-gray-400">
            <li>
              <Link to="/" className="hover:text-white transition">
                Home
              </Link>
            </li>

            <li>
              <Link to="/about" className="hover:text-white transition">
                About
              </Link>
            </li>

            <li>
              <Link to="/services" className="hover:text-white transition">
                Services
              </Link>
            </li>

            <li>
              <Link to="/countries" className="hover:text-white transition">
                Countries
              </Link>
            </li>

            <li>
              <Link to="/contact" className="hover:text-white transition">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* SERVICES */}

        <div>
          <h3 className="text-xl font-semibold mb-6">Our Services</h3>

          <ul className="space-y-3 text-gray-400">
            <li>
              <Link
                to="/services/work-visa"
                className="hover:text-white transition"
              >
                Work Visa Assistance
              </Link>
            </li>

            <li>
              <Link
                to="/services/student-visa"
                className="hover:text-white transition"
              >
                Student Visa Services
              </Link>
            </li>

            <li>
              <Link
                to="/services/travel-visa"
                className="hover:text-white transition"
              >
                Tourist & Travel Visa
              </Link>
            </li>

            <li>
              <Link
                to="/services/business-visa"
                className="hover:text-white transition"
              >
                Business Visa Support
              </Link>
            </li>

            <li>
              <Link
                to="/services/attestation"
                className="hover:text-white transition"
              >
                Certificate Attestation
              </Link>
            </li>
          </ul>
        </div>

        {/* CONTACT */}

        <div>
          <h3 className="text-xl font-semibold mb-6">Contact Us</h3>

          <div className="space-y-4 text-gray-400 text-sm">
            {/* LOCATION */}

            <a
              href="https://maps.google.com/?q=Lake+Central+Tower+Business+Bay+Dubai"
              target="_blank"
              rel="noreferrer"
              className="flex gap-3 hover:text-white transition"
            >
              <FaMapMarkerAlt className="text-blue-400 mt-1" />
              Lake Central Tower, Business Bay, Dubai
            </a>

            {/* PHONE */}

            <a
              href="tel:+971547662665"
              className="flex gap-3 hover:text-white transition"
            >
              <FaPhoneAlt className="text-blue-400 mt-1" />
              +971 54 766 2665
            </a>

            {/* EMAIL */}

            <a
              href="mailto:info@lumisdocumentsclearing.com"
              className="flex gap-3 hover:text-white transition"
            >
              <FaEnvelope className="text-blue-400 mt-1" />
              info@lumisdocumentsclearing.com
            </a>

            {/* HOURS */}

            <div className="flex gap-3">
              <FaClock className="text-blue-400 mt-1" />
              Mon - Fri 9:30AM - 6:30PM
            </div>
          </div>
        </div>
      </div>

      {/* SOCIAL + COPYRIGHT */}

      <div className="border-t border-gray-800 pt-8 pb-6">
        <div className="max-w-7xl mx-auto px-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Lumis Documents Clearing. All rights
            reserved.
          </p>

          {/* SOCIAL ICONS */}

          <div className="flex gap-6 text-xl">
            <a href="#!" className="text-gray-400 hover:text-white transition">
              <FaFacebook />
            </a>

            <a href="#!" className="text-gray-400 hover:text-white transition">
              <FaInstagram />
            </a>

            <a href="#!" className="text-gray-400 hover:text-white transition">
              <FaLinkedin />
            </a>

            <a
              href="https://wa.me/971547662665"
              target="_blank"
              rel="noreferrer"
              className="text-gray-400 hover:text-green-400 transition"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
